import { IApplicationState } from '../../types/redux';

export function selectPhoneNumber(state: IApplicationState) {
  return state.phone.phoneNumber;
}
